<template>
    <div class="board" v-if="formData && errorData">
        <div class="bar">
            <b-icon icon="card-text" class="icon"></b-icon>
            <span>สำหรับออกบิล</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <div class="form">
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label>วิธีชำระเงิน</label>
                            <dropdown
                                v-model="formData.bill.paymentMethod"
                                placeholder="วิธีชำระเงิน"
                                :options="option.paymentMethod"
                                :disabled="jobState === $Constants.JOB_STATUS_COMPLETE"
                                :classes="{ input: [ 'input-field', errorData.bill.paymentMethod.blank ? 'invalid' : '' ] }"
                                @change="checkIncludeTax($event)"
                            ></dropdown>
                            <div class="input-error-message" v-if="errorData.bill.paymentMethod.blank">โปรดเลือกวิธีชำระเงิน</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-4">
                        <div class="field">
                            <label class="no-label">-</label>
                            <checkbox v-model="formData.bill.includeTax" class="mr-3" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE || formData.bill.paymentMethod !== $Constants.PAYMENT_METHOD_CASH">บวกภาษีเพิ่ม (7%)</checkbox>
                        </div>
                    </div>
                </div>
                
                <div class="filter mt-3">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field mb-4">
                                <switch-button v-model="formData.tax.requireTax" :readonly="jobState === $Constants.JOB_STATUS_COMPLETE">ต้องการใบกำกับภาษี</switch-button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>ชื่อ-นามสกุล/ชื่อบริษัท</label>
                                <input type="text"
                                    v-model="formData.tax.taxName"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.tax.taxName.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="100"
                                    placeholder="ชื่อ-นามสกุล/ชื่อบริษัท" />
                                <div class="input-error-message" v-if="errorData.tax.taxName.blank">โปรดกรอกชื่อ-นามสกุล/ชื่อบริษัท</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>เลขที่ประจำตัวผู้เสียภาษี</label>
                                <input type="tel"
                                    v-model="formData.tax.taxId"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.tax.taxId.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="20"
                                    @keypress="$AppUtility.inputOnlyNumber($event)"
                                    placeholder="เลขที่ประจำตัวผู้เสียภาษี" />
                                <div class="input-error-message" v-if="errorData.tax.taxId.blank">โปรดกรอกเลขที่ประจำตัวผู้เสียภาษี</div>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4">
                            <div class="field">
                                <label>ที่อยู่ในใบกำกับภาษี</label>
                                <input type="tel"
                                    v-model="formData.tax.taxAddress"
                                    class="input-field"
                                    :class="{ 'invalid': errorData.tax.taxAddress.blank }"
                                    :readonly="jobState === $Constants.JOB_STATUS_COMPLETE"
                                    maxlength="100"
                                    placeholder="ที่อยู่ในใบกำกับภาษี" />
                                <div class="input-error-message" v-if="errorData.tax.taxAddress.blank">โปรดกรอกที่อยู่ในใบกำกับภาษี</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MixinThemeBoard from '@/theme/script/Board';
import MixinFormData from '@/components/job/FormData';
import OptionPaymentMethod from '@/database/staticOption/PaymentMethod';

export default {
    mixins: [ MixinThemeBoard, MixinFormData],
    data() {
        return {
            formData: null,
            option: {
                paymentMethod: []
            }
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    async mounted() {
        await this.initOptionData();
        this.pageLoad();
    },
    methods: {
        async initOptionData() {
            this.option.paymentMethod = OptionPaymentMethod.option;
        },
        pageLoad() {
            this.formData = this.initForm();
            this.$emit('formData', this.formData);
        },
        initForm() {
            return {
                bill: {
                    paymentMethod: this.loadData ? this.loadData.bill.paymentMethod : '',
                    includeTax: this.loadData ? this.loadData.bill.includeTax : true
                },
                tax: {
                    requireTax: this.loadData ? this.loadData.tax.requireTax : false,
                    taxName: this.loadData ? this.loadData.tax.taxName : '',
                    taxId: this.loadData ? this.loadData.tax.taxId : '',
                    taxAddress: this.loadData ? this.loadData.tax.taxAddress : ''
                }
            };
        },
        checkIncludeTax(value) {
            if (value !== this.$Constants.PAYMENT_METHOD_CASH) {
                this.formData.bill.includeTax = true;
            }
        }
    }
}
</script>